import { z } from "zod";
import type { StorageItemId } from "./storage-item-id";
import {
    storageItemImageFactory,
    storageItemImageZodSchema,
} from "./storage-item-images/storage-item-image";
import type {
    StorageItemImageId} from "./storage-item-images/storage-item-image-id";
import {
    isStorageItemImageId
} from "./storage-item-images/storage-item-image-id";
import {
    storageItemPdfFactory,
    storageItemPdfZodSchema,
} from "./storage-item-pdfs/storage-item-pdf";
import type {
    StorageItemPdfId} from "./storage-item-pdfs/storage-item-pdf-id";
import {
    isStorageItemPdfId
} from "./storage-item-pdfs/storage-item-pdf-id";
import {
    storageItemSvgFactory,
    storageItemSvgZodSchema,
} from "./storage-item-svgs/storage-item-svg";
import type {
    StorageItemSvgId} from "./storage-item-svgs/storage-item-svg-id";
import {
    isStorageItemSvgId
} from "./storage-item-svgs/storage-item-svg-id";

/** Stores meta data about user uploaded files of different kinds */
const storageItemZodSchema = z.discriminatedUnion("type", [
    storageItemImageZodSchema,
    storageItemPdfZodSchema,
    storageItemSvgZodSchema,
]);
type StorageItem = z.infer<typeof storageItemZodSchema>;

function getStorageItemFactory(
    storageItemId: StorageItemImageId
): typeof storageItemImageFactory;
function getStorageItemFactory(
    storageItemId: StorageItemPdfId
): typeof storageItemPdfFactory;
function getStorageItemFactory(
    storageItemId: StorageItemSvgId
): typeof storageItemSvgFactory;
function getStorageItemFactory(storageItemId: StorageItemId) {
    if (isStorageItemImageId(storageItemId)) return storageItemImageFactory;
    if (isStorageItemPdfId(storageItemId)) return storageItemPdfFactory;
    if (isStorageItemSvgId(storageItemId)) return storageItemSvgFactory;
    throw new Error("unhandled storage item id type; " + storageItemId);
}

export type { StorageItem };
export { getStorageItemFactory, storageItemZodSchema };
